<template>
  <div id="municipalInfoDetail" data-role="page">
    <!-- content -->
    <div class="municipalInfoDetail-content" data-position="fixed">
        <!-- 未連接至網路的提醒 -->
        <div v-if="!closeOffline && isOffline" class="v3offline">
            <i class="icon-exclamation-mark-circle"></i>
            <p>未連接至網路</p>
            <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
        </div>
      <div class="detailWrap" v-if="detailData.content">
        <div class="detail-h">
          <template v-if="detailData.type == 'municipal'">
            <span class="cgy-tag">{{ detailData.content.MessageType }}</span>
          </template>
          <template v-else-if="detailData.type == 'village'">
            <template v-if="isGetProfileInfoSuccess">
              <span v-if="villageIdx < 3" class="cgy-tag" v-for="(villageVal,villageIdx) in detailData.content.VillageName" :key="villageIdx">{{ villageVal }}</span>
              <span v-if="detailData.content.VillageName.length > 3" class="cgy-tag">＋{{ detailData.content.VillageName.length - 3 }}</span>
            </template>
          </template>
          <h3 :class="{'LargSize':fz_larg}">{{ detailData.content.MessageTitle }}</h3>
          <span class="article_date" :class="{'LargSize':fz_larg}">{{ dateFormat(detailData.content.MessageDate,'YYYY/MM/DD') }}</span>
        </div>
        <!-- 文章內容 -->
        <div class="detail-c">
          <div class="txtContent" :class="{'LargSize':fz_larg}">
            <p v-html="contentTransform(detailData.content.MessageContent)"></p>
          </div>
        </div>
        <!-- /文章內容 -->
        <!-- 附檔 -->
        <div class="detail-a" v-if="detailData.content.Files && detailData.content.Files.length>0">
          <div class="attachTitle">檢視附加檔案</div>
          <div class="attachFileWrap" :class="{'LargSize':fz_larg}">
            <div v-for="(files, fileIdx) in detailData.content.Files" :key="fileIdx" class="attachFile" @click="OpenFile(files.FileLink, files.FileName)">
              <i class="icon-clip"></i>
              <span>{{ files.FileName }}</span>
            </div>
          </div>
        </div>
        <!-- /附檔 -->
      </div>
    </div>
    <!-- /content -->
    <!-- footer -->
    <!-- <div class="qk-functionBar active" v-if="Authority">
      <div :class="[Authority? 'qk-functionBar-wrap-col4':'qk-functionBar-wrap-col1']">
        <div v-on:click="Share()"><span><i class="icon-share"></i>分享</span></div>
        <div v-on:click="ChanegSize"><span><i class="icon-letterA"></i>大小</span></div>
      </div>
    </div> -->
    <div id="v3functionBar" class="qk-functionBar active" v-if="Authority">
        <div :class="['qk-functionBar-wrap-col4']">
            <div class="fontsize-option" v-on:click="ChanegSize" :class="{active: fz_larg}"><span><i class="icon-font-size"></i>大小</span></div>
            <div class="share-option" @click="Share"><span><i class="icon-export"></i>分享</span></div>
        </div>               
    </div>
    <!-- /footer -->
    <div v-show="v3Toast.show" class="v3Toast">{{v3Toast.text}}</div>
  </div>
</template>

<script lang="js">
export default {
    data () {
        return {
            detailData: {
                type: '',
                content: ''
            },
            Authority: false,   
            fz_larg: false,
            toastControl:{
                show: false,
                full: false,
                content: '',
                showTime: 1000
            },
            scrollPrevioustTicks:0,
            comList: [],
            isGetProfileInfoSuccess: true,
             v3Toast:{
                show: false,
                text: '',
                duration: 1000
            },
            detailId:this.$route.params.id,
            detailType:this.$route.params.type,
            closeOffline:false,
        }
    },
    watch: {
        isOffline: function(val) {
            // 在下次無網路時再度打開上面的 top tip
            if (!val) this.closeOffline = false
        }
    },
    mounted(){
        let vobj = this;
        this.CheckAuthority();
        const type = this.$route.params.type;
        const id = this.$route.params.id;
        window.addEventListener('scroll', this.handleScroll);
        this.GetProfileInfo().then((r)=>{
            this.Authority= true
            this.isGetProfileInfoSuccess = true
            let isNtpc = this.comList.some((v)=>{
                if(v.municipalType == 'Ntpc'){
                    return true
                }
            })
            var villageList = this.comList.map((v)=>{
                if(v.villageId != null){
                    return v.villageId
                }
            })
            villageList = Array.from(new Set(villageList))
            if(type == 'municipal' && isNtpc){
                this.GetMunicipalList('Ntpc').then((r)=>{
                    this.detailData.type = 'municipal'
                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    this.detailData.content = (filterData && filterData.length > 0) ? filterData[0] : null
                })
            }
            if(type == 'village'){
                this.GetVillageList(villageList).then((r)=>{
                    this.detailData.type = 'village'
                    r = r.map((v)=>{
                        v.VillageName = v.VillageName.filter((village)=>{
                            return village != null
                        })
                        v.VillageName = Array.from(new Set(v.VillageName)) //篩選重複項
                        return v
                    })

                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    var showData = null
                    if(filterData && filterData.length > 0){
                        showData = filterData.map((v)=>{
                            v.VillageName = v.VillageName.filter((village)=>{
                                return village != null
                            })
                            v.VillageName = Array.from(new Set(v.VillageName)) //篩選重複項
                            return v
                        })
                    }
                    this.detailData.content = (showData && showData.length > 0) ? showData[0] : null
                })
            }
        }).catch((e)=>{
            this.Authority= false
            this.isGetProfileInfoSuccess = false
            const type = this.$route.params.type;
            const id = this.$route.params.id;
            if(type == 'municipal'){
                this.GetMunicipalList('Ntpc').then((r)=>{
                    this.detailData.type = 'municipal'
                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    this.detailData.content = (filterData && filterData.length > 0) ? filterData[0] : null
                })
            }
            if(type == 'village'){
                this.GetVillageList([]).then((r)=>{
                    this.detailData.type = 'village'
                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    this.detailData.content = (filterData && filterData.length > 0) ? filterData[0] : null
                })
            }
        })
        
    },
    methods:{
        //底部功能表示窗滾動事件
        handleScroll () {
            let scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();

            if(this.scrollPrevioustTicks<window.scrollY){
                //向下滑動
                $('.qk-functionBar').removeClass('active')
                if(scrollBottom == 0){$('.qk-functionBar').addClass('active')} 
            }else if(this.scrollPrevioustTicks>window.scrollY){
                //向上滑動
                $('.qk-functionBar').addClass('active')
            }
            this.scrollPrevioustTicks = window.scrollY;
        },
        //取得市政訊息列表
        GetMunicipalList(municipalType){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                this.axios.get(`${process.env.SmartlifeCoreApi}/MunicipalInformation/${municipalType}`,{
                    // headers:{Authorization: Token},
                }).then((response) => {
                    if(response.status == 200){
                        resolve(response.data.Data)
                    }else{
                        Promise.reject('status 不是200')
                    }
                }).catch((err) => {
                    reject()
                })
            })
        },
        //取得新訊列表
        GetVillageList(villageId){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                this.axios.get(`${process.env.SmartlifeCoreApi}/MunicipalInformation/Village/`,{
                    // headers:{Authorization: Token},
                    params: {
                        villageIds: villageId
                    }
                }).then((response) => {
                    if(response.status == 200){
                        resolve(response.data.Data)
                    }else{
                        Promise.reject('status 不是200')
                    }
                }).catch((err) => {
                    console.log(err)
                    reject()
                })
            })
        },
        //取得使用者社區資料
        GetProfileInfo(){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                if(!v3Token || v3Token=='undefined' || v3Token=='null'){ 
                    return reject()
                }
                this.axios.get(`${process.env.SmartlifeCoreApi}/Profile/GetProfileInfo/`,{
                    headers:{KingnetAuth: 'CommunityUser ' + decodeURIComponent(v3Token)}
                }).then((response) => {
                    if(response.data && response.data.Data && response.data.Data.plist && response.data.Data.plist.length>0){
                        this.comList = response.data.Data.plist
                        resolve(this.comList)
                    }else{
                        reject()
                    }
                }).catch((err) => {
                    reject()
                })
            })
        },
        //取得短網址
        GetShortUrl(url){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                this.axios.get(`${process.env.ecsApi}/Order/GetDynamicLink/`,{
                    headers:{Authorization: decodeURIComponent(v3Token)},
                    params: {
                        url: url
                    }
                }).then((response) => {
                    if(response.status == 200){
                        resolve(response.data.Data)
                    }else{
                        reject('status 不是200')
                    }
                }).catch((err) => {
                    console.log(err)
                    reject()
                })
            })
        },
        //檢查權限
        CheckAuthority(){
            if(localStorage.getItem("v3token")=='' || localStorage.getItem("v3token") == null){
                this.Authority= false
            }else{
                this.Authority= true
            }
        },
        dateFormat(date, format){
            if(date){
                return this.$root.dateFormat(date, format)
            }else{
                return ''
            }
        },
        contentTransform(content){
            let returnObj = content
            if(returnObj){
                return returnObj.replace(/\n/g,'<br>')
            }else{
                return returnObj
            }
            
        },
        //文字大小變化
        ChanegSize(){
            this.fz_larg ? this.fz_larg=false : this.fz_larg=true;
        },
        //複製網址
        copyLink(id,title){
            let vm = this   
            console.log(process.env);
            
            let domain = ''
            switch (process.env.ENV_CONFIG) {
                case 'local':
                    domain = "https://dist-dev.kingnetsmart.com.tw/#/v3municipalInfoDetail/municipal/"
                break;
                case 'staging':
                    domain = "https://dist-staging.kingnetsmart.com.tw/#/v3municipalInfoDetail/municipal/"
                break;
                case 'master':
                    domain = "https://dist.kingnetsmart.com.tw/#/v3municipalInfoDetail/municipal/"
                break;
            }     
                // let copytext = `我在智生活看到【${title}】分享給你!｜新北市政資訊\n ${shortLink}`
                let copytext = `我在智生活看到【${title}】分享給你!｜新北市政資訊\n ${domain}${vm.$route.params.id}`
                console.log(copytext,'copytext')
                vm.$copyText(copytext).then(
                    function (e) {
                        vm.showV3Toast('已複製到剪貼簿')
                    }, 
                    function (e) {
                        console.log(e,'eee')
                        vm.showV3Toast('未能成功複製到剪貼簿')
                    }
                )  
                // vm.GetShortUrl(`${domain}${vm.$route.params.id}`).then(res=>{
                //     let link = res.shortLink
                //     let copytext = `我在智生活看到【${title}】分享給你!｜新北市政資訊\n ${link}`
                //     // let copytext = `我在智生活看到【${title}】分享給你!｜新北市政資訊\n${domain}${vm.$route.params.id}`
                //     console.log(copytext,'copytext')
                //     setTimeout(() => {
                //          vm.$copyText(copytext).then(
                //         function (e) {
                //             vm.showV3Toast('已複製到剪貼簿')
                //         }, 
                //         function (e) {
                //             console.log(e,'eee')
                //             vm.showV3Toast('未能成功複製到剪貼簿')
                //         }
                //     )  
                //     }, 300);
                   
                // })
           
        },
        showV3Toast(text) {
            clearTimeout(this.toastTimer)
            this.v3Toast.text = text;
            this.v3Toast.show = true;
            this.toastTimer = setTimeout(() => {
                this.v3Toast.show = false;
            }, this.v3Toast.duration);
        },
        //打開檔案
        OpenFile(link, title){
            window.open(`https://inapp.kingnetsmart.com.tw/ad.html?page=linkRule&params1=7&params2=${encodeURIComponent(link)}&title=${encodeURIComponent(title)}&referrer=${encodeURIComponent(location.href)}`,'_blank')
        },
        //分享按鈕     
        Share(){
            document.location.replace(`/#/v3municipalInfoDetail/${this.detailType}/${this.detailId}/?KNSTMethod=share&title=${encodeURIComponent(this.detailData.content.MessageTitle)}`)
        },
        closeOfflineHandle(){
            this.closeOffline = true
        }
    },
}
</script>
<style lang="css" scoped>
.v3Toast {
  position: fixed;
  left: 50%;
  top: 50%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  background: rgba(0, 0, 0, 0.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  color: #fff;
  font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  font-weight: 500;
}
.v3offline {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 44px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 21px;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    background: rgba(66, 137, 167, .9); /* #4289a7 2020/11/19 13:37 BD mean this color */ 
    -webkit-transition: .5s;
    transition: .5s;
}
.v3offline > i {
    margin-right: 9px;
    font-size: 19px;
    width: 19px;
    height: 19px;
}
.v3offline div {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 18px;
    width: 18px;
    height: 18px;
}
.detail-c .txtContent p {
    word-break: break-word;;
}
/* v3functionBar */

#v3functionBar.active {
    background: transparent;
    opacity: 1;
    bottom: 24px;
}

#v3functionBar [class|=qk-functionBar-wrap] {
    width: auto;
    margin: 0 8px;
    padding: 0 8px;
    border-radius: 23px;
    box-shadow: 0 3px 6px rgba(0,0,0,.2);
    background-color: #fff;
}

#v3functionBar [class|=qk-functionBar-wrap] div {
    background: transparent;
}
#v3functionBar [class|=qk-functionBar-wrap] span {
    font-size: 13px;
    color: #484848;
}

#v3functionBar [class|=qk-functionBar-wrap] div.active i {
    color: #46b39a;
}

#v3functionBar [class|=qk-functionBar-wrap] div.active span {
    color: #46b39a;
}
#v3functionBar .fontsize-option{
    float: left;
    width: 50%;
}
#v3functionBar .share-option{
    float: none;
    width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/v3/municipal/municipalInfoDetail.vue